import { TextInput } from '@uplift/ui-v2';
import { useProfileStyles } from '../styles';
import { useFormikContext } from 'formik';
import { PreferredNamePreview } from '../../../components';

type PreferredNameForm = { preferredName: string };

export const NameForm: React.VFC = () => {
  const { classes } = useProfileStyles();
  const { values } = useFormikContext<PreferredNameForm>();

  return (
    <div>
      <TextInput
        label="(Optional)"
        name="preferredName"
        fullWidth
        inputClasses={{ root: classes.maxWidth400 }}
      />
      <PreferredNamePreview preferredName={values.preferredName} />
    </div>
  );
};
